import axios from 'axios'
import AppPath from './AppPath'
import Util from './Util'

async function axiosGetWithSanitize(url, options) {
    // 自前のサニタイズを挟むためtextで受け取りたいが、axiosのバグでresponseType: 'text'が機能しないためtransformResponse: nullを指定する
    // https://github.com/axios/axios/issues/907#issuecomment-373988087
    const response = await axios.get(url, { transformResponse: null, ...options });
    if (response.status !== 200) throw new Error('通信に失敗');
    // console.log(response.data)

    // 文字列のみサニタイズする
    return JSON.parse(response.data, (k,v) => typeof v === 'string' ? Util.sanitize.encode(v) : v);
}

const resolveTagData = (() => {
    //タグデータは頻繁に引っ張ってくることになるのでキャッシュしておく
    const tag_data_promise = axiosGetWithSanitize(`${AppPath.api}get_all_tags`);
    let data_cache = null;

    return function () {
        if (data_cache) {
            return data_cache;
        } else {
            return data_cache = new Promise(async r => {
                const response_data = await tag_data_promise;
                r(response_data);
            });
        }
    }
})();
const getTagNameList = (() => {
    //結果をキャッシュする
    let data_cache = null;

    return async function () {
        if (data_cache) {
            return data_cache;
        } else {
            return data_cache = new Promise(async r => {
                const tag_data = await resolveTagData();
                r(tag_data.map(d => d.name_en));
            });
        }
    }
})();

async function formatRawPictureData(picture_data) {
    picture_data = await formatTagList(picture_data);
    return formatMarkList(picture_data);
}
async function formatTagList(picture_data) {
    const [tag_data, tag_name_list] = await Promise.all([resolveTagData(), getTagNameList()]);
    const data = {...picture_data};
    const tags = [];
    for (const [key, value] of Object.entries(data)) {
        if ( tag_name_list.includes(key) ) {
            delete data[key];
            if (value === '1') tags.push( tag_data.find(d => d.name_en === key) );
        }
    }
    data.tags = tags;
    return data
}
function formatMarkList(picture_data) {
    const data = {...picture_data};
    const mark_list = [];
    for (let i = 1; i <= 11; i++) {
        const keys = [`pos${i}_url`, `pos${i}_x`, `pos${i}_y`];
        const mark = keys.map(key => {
            const tmp = data[key];
            delete data[key];
            return tmp;
        });
        if ( mark.every(d => d) ) mark_list.push(mark);
    }
    return {...data, marks: mark_list};
}

export default {

    //select
    async getSearchTags() {
        const tag_data = await resolveTagData();

        const tags = {};
        tag_data.forEach(tag => {
            const category = tag.category;
            if (!tags[category]) tags[category] = [];
            tags[category].push(tag);
        });

        return tags;
    },
    async getTagData() {
        return await resolveTagData();
    },
    async pictureSearch(search_tags = [], start = 0, limit = 30, or_flag = null, search_text = '', opening_flap_pages = null) {
        const tags = search_tags.map(tag => tag.name_en);
        const url = `${AppPath.api}get_photos`;
        const params = {tags, start, limit, or_flag, search_text};
        if (opening_flap_pages) params.opening_flap_pages = opening_flap_pages;
        const response_data = await axiosGetWithSanitize(url, {params});

        return await Promise.all( response_data.map(formatRawPictureData) );
    },
    async getRoomInfo(room_id) {
        const url = `${AppPath.api}get_room_info`;
        const params = {room_id};
        const response_data = await axiosGetWithSanitize(url, {params});

        if (response_data) return await formatRawPictureData( response_data );
        else return null
    },
    async getUserData() {
        const url = `${AppPath.api}get_user_data`;
        const response_data = await axiosGetWithSanitize(url);

        return response_data || null;
    },
    async getSukikamoList() {
        const url = `${AppPath.api}get_sukikamo_list`;
        const response_data = await axiosGetWithSanitize(url);

        return response_data || null;
    },
    async getAllSukikamo() {
        const url = `${AppPath.api}get_all_sukikamo`;
        const response_data = await axiosGetWithSanitize(url);

        if ( !response_data ) return {};

        Object.keys(response_data).forEach(async key => {
            const items = response_data[key].items;
            response_data[key].items = await Promise.all( items.map(formatRawPictureData) )
        });
        return response_data;
    },
    async getPlanBoardItems() {
        const url = `${AppPath.api}get_plan_board_items`;
        const response_data = await axiosGetWithSanitize(url);

        return response_data || [];
    },

    //insert
    async addSukikamoList(name) {
        const url = `${AppPath.api}add_sukikamo_list`;
        const params = {name};
        const response_data = await axiosGetWithSanitize(url, {params});

        return response_data.success || false;
    },
    async addSukikamoListItem(list_id, photo_id) {
        const url = `${AppPath.api}add_sukikamo_list_item`;
        const params = {list_id, photo_id};
        const response_data = await axiosGetWithSanitize(url, {params});

        return response_data.success || false;
    },
    async addPlanBoardItem(list_id, photo_id) {
        const url = `${AppPath.api}add_plan_board_item`;
        const params = {list_id, photo_id};
        const response_data = await axiosGetWithSanitize(url, {params});

        return response_data.success || false;
    },

    //update
    async updateSukikamoListName(list_id, name) {
        const url = `${AppPath.api}update_sukikamo_list_name`;
        const params = {list_id, name};
        const response_data = await axiosGetWithSanitize(url, {params});

        return response_data.success || false;
    },

    //delete
    async removeSukikamoList(list_id) {
        const url = `${AppPath.api}remove_sukikamo_list`;
        const params = {list_id};
        const response_data = await axiosGetWithSanitize(url, {params});

        return response_data.success || false;
    },
    async removeSukikamoListItem(list_id, photo_id) {
        const url = `${AppPath.api}remove_sukikamo_list_item`;
        const params = {list_id, photo_id};
        const response_data = await axiosGetWithSanitize(url, {params});

        return response_data.success || false;
    },
    async removePlanBoardItem(list_id, photo_id) {
        const url = `${AppPath.api}remove_plan_board_item`;
        const params = {list_id, photo_id};
        const response_data = await axiosGetWithSanitize(url, {params});

        return response_data.success || false;
    }
}
